export default "__VITE_ASSET__cf7930e2__"